import { Button, ButtonIconContainer, ButtonInnerContainer } from 'components/atoms/Button'
import styled from 'styled-components'

export const LoginButton = styled(Button)`
  width: 300px;
  max-width: 300px;

  ${ButtonInnerContainer} {
    position: initial;
  }

  ${ButtonIconContainer} {
    left: 16px;
  }
`
